import React, { useContext } from 'react';
import { get } from 'lodash';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import {
  useEventCallback,
  NavigationContext,
  DashboardCardAction,
  DashboardCardProps,
} from '@eas/common-web';
import { EvidenceUrl } from '../../../enums';
import { CustomCardBase } from './custom-card-base';

export function CardSubjects({ report, definitionId }: DashboardCardProps) {
  const { navigate } = useContext(NavigationContext);

  const count = get(report, 'data[0].count');
  const requestCount = get(report, 'data[1].count');

  const navigateMain = useEventCallback(() => {
    navigate(EvidenceUrl.SUBJECTS);
  });

  const navigateRequests = useEventCallback(() => {
    navigate(EvidenceUrl.SUBJECT_REQUESTS);
  });

  const navigateNewRegistration = useEventCallback(() => {
    navigate(EvidenceUrl.SUBJECT_REQUESTS_NEW);
  });

  return (
    <CustomCardBase
      title="Registr subjektů"
      definitionId={definitionId}
      value={count}
      icon={<SupervisedUserCircleIcon />}
      navigate={navigateMain}
    >
      <DashboardCardAction
        navigate={navigateRequests}
        title="Nevyřešené žádosti:"
        value={requestCount}
      />
      <DashboardCardAction
        navigate={navigateNewRegistration}
        title="Nová registrace"
      />
    </CustomCardBase>
  );
}
